<!-- "New Discovery" dialog -->
<p-dialog modal="true" appendTo="body" [(visible)]="display" (onHide)="onDialogHide()" [resizable]="false">

	<p-header>
		<span>Enter a name for your new discovery</span>
	</p-header>

	<div>
		<label for="name">Name</label><br />
		<input name="name" type="text" style="width: 100%;" pInputText [(ngModel)]="newItemName" />
	</div>

	<p-footer>
		<button type="button" pButton icon="fa fa-check" (click)="hideDialog(); addNewDiscovery()" label="OK"></button>
		<button type="button" pButton icon="fa fa-close" (click)="hideDialog()" label="Cancel"></button>
	</p-footer>

</p-dialog>
